import {
  IMG_CRUISE_LOCATION_CUSTOMS_DONGGU,
  IMG_CRUISE_LOCATION_PRINT_DONGGU,
  IMG_PRINT_GIMHAE_2,
  IMG_PRINT_GIMHEA_1,
  IMG_PRINT_GIMPO_1,
  IMG_PRINT_GIMPO_2,
  IMG_PRINT_INCHEON_T1_1,
  IMG_PRINT_INCHEON_T2_1,
  IMG_PRINT_INCHEON_T2_2,
  IMG_PRINT_MAP_GIMHAE_1,
  IMG_PRINT_MAP_GIMHAE_2,
  IMG_PRINT_MAP_GIMPO_1,
  IMG_PRINT_MAP_INCHEON_1,
  IMG_PRINT_MAP_INCHEON_T2_1,
  IMG_PRINT_MAP_INCHEON_T2_2,
} from '@repo/assets';
import { VAN_REFUNDABLE_AIRPORT_CODE } from '@repo/types';

export type LocationPrintAirport = Exclude<
  VAN_REFUNDABLE_AIRPORT_CODE,
  'VAN_ETC' | 'UNKNOWN' | 'KIOSK'
>;

type LocationPrintCruise =
  | 'IncheonIntl'
  | 'IncheonCruise'
  | 'donggu'
  | 'yeongdogu';

type LocationPrint = {
  key: LocationPrintAirport | LocationPrintCruise;
  name: string;
  nameKor: string;
};

type LocationPrintDetail = {
  type: { eng: string; kor: string; isFillColor?: boolean }[];
  location: { eng: string; kor: string };
  time: string;
  tel: string;
  img: string;
  map: string;
};

export const LOCATION_PRINT: LocationPrint[] = [
  {
    key: 'ICN_TERMINAL1',
    name: 'Incheon Airport T1',
    nameKor: '인천공항 T1',
  },
  {
    key: 'ICN_TERMINAL2',
    name: 'Incheon Airport T2',
    nameKor: '인천공항 T2',
  },
  {
    key: 'GMP',
    name: 'Gimpo Airport',
    nameKor: '김포공항',
  },
  {
    key: 'KIH',
    name: 'Gimhae Airport',
    nameKor: '김해공항',
  },
];

export const LOCATION_PRINT_DETAIL: Record<
  LocationPrintAirport,
  LocationPrintDetail[]
> = {
  ICN_TERMINAL1: [
    {
      type: [
        { eng: 'Check-in-Area', kor: '일반 구역', isFillColor: true },
        { eng: 'Only Cash', kor: '현금결제만 가능' },
      ],
      location: {
        eng: '3F Counter-H Library (K-Books)',
        kor: '3층 H 카운터 부근 서점 (K-Books)',
      },
      time: '06:30 ~ 21:30',
      tel: '032-743-0092',
      img: IMG_PRINT_INCHEON_T1_1,
      map: IMG_PRINT_MAP_INCHEON_1,
    },
  ],
  ICN_TERMINAL2: [
    {
      type: [
        { eng: 'Check-in-Area', kor: '일반 구역', isFillColor: true },
        { eng: 'Only Cash', kor: '현금결제만 가능' },
      ],
      location: { eng: 'B1 Starbucks', kor: '지하1층 중앙 스타벅스' },
      time: '00:00 ~ 24:00',
      tel: '032-743-8258',
      img: IMG_PRINT_INCHEON_T2_1,
      map: IMG_PRINT_MAP_INCHEON_T2_1,
    },
    {
      type: [
        { eng: 'Check-in-Area', kor: '일반 구역', isFillColor: true },
        { eng: 'Only Cash', kor: '현금결제만 가능' },
      ],
      location: {
        eng: '3F Counter-F Travel Mate',
        kor: '3층 F카운터 부근 트레블메이트',
      },
      time: '06:00 ~ 22:00',
      tel: '032-743-4313',
      img: IMG_PRINT_INCHEON_T2_2,
      map: IMG_PRINT_MAP_INCHEON_T2_2,
    },
  ],
  GMP: [
    {
      type: [{ eng: 'Gimpo Airport Metro', kor: '김포공항역' }],
      location: {
        eng: 'Lotte Mart Gimpo Airport Branch - PRINT CAFE 24',
        kor: '롯데마트 김포공항점 PRINT CAFE 24',
      },
      time: '',
      tel: '',
      img: IMG_PRINT_GIMPO_2,
      map: '',
    },
    {
      type: [{ eng: 'Domestic', kor: '국내선' }],
      location: {
        eng: '4F Near Lotteria in the food court',
        kor: '4층 출국장 위 푸드코트 롯데리아 부근',
      },
      time: '',
      tel: '',
      img: IMG_PRINT_GIMPO_1,
      map: IMG_PRINT_MAP_GIMPO_1,
    },
  ],
  KIH: [
    {
      type: [{ eng: 'Domestic', kor: '국내선' }],
      location: { eng: '2F Zim Carry', kor: '2층 짐캐리' },
      time: 'Open Time : 09:00 ~ 18:00',
      tel: '',
      img: IMG_PRINT_GIMHEA_1,
      map: IMG_PRINT_MAP_GIMHAE_1,
    },
    {
      type: [{ eng: 'International', kor: '국제선' }],
      location: { eng: '3F Opposite Lotteria', kor: '3층 롯데리아 맞은편' },
      time: '',
      tel: '',
      img: IMG_PRINT_GIMHAE_2,
      map: IMG_PRINT_MAP_GIMHAE_2,
    },
  ],
};

export const LOCATION_PRINT_CRUISE: LocationPrint[] = [
  {
    key: 'IncheonIntl',
    name: '인천항 국제 여객 터미널',
    nameKor: 'Incheon Intl. Passenger Terminal',
  },
  {
    key: 'IncheonCruise',
    name: '인천항 크루즈 터미널',
    nameKor: 'Incheon Cruise Terminal',
  },
  {
    key: 'donggu',
    name: '부산항(동구)',
    nameKor: 'Busan Port (Dong-gu)',
  },
  {
    key: 'yeongdogu',
    name: '부산항(영동구)',
    nameKor: 'Busan Port (Yeongdo-gu)',
  },
];

export const LOCATION_PRINT_DETAIL_CRUISE = {
  IncheonIntl: [],
  IncheonCruise: [],
  donggu: [
    {
      type: [{ eng: 'Busan Port (Dong-gu)', kor: '일반 구역' }],
      location: {
        eng: '2F Cafe DROPTOP',
        kor: '2층 카페 DROPTOP',
      },
      time: '',
      tel: '',
      img: IMG_CRUISE_LOCATION_PRINT_DONGGU,
      map: IMG_CRUISE_LOCATION_CUSTOMS_DONGGU,
      viewMap:
        'https://www.google.com/maps/place/%EB%B6%80%EC%82%B0%ED%95%AD+%EA%B5%AD%EC%A0%9C%EC%97%AC%EA%B0%9D%ED%84%B0%EB%AF%B8%EB%84%90/data=!3m2!1e3!4b1!4m6!3m5!1s0x3568ebdc268b3061:0xf69a45e35279e8ac!8m2!3d35.1174375!4d129.0486875!16s%2Fg%2F1229qm0r?entry=ttu&g_ep=EgoyMDI1MTEzMC4wIKXMDSoASAFQAw%3D%3D',
    },
  ],
  yeongdogu: [],
};
